import { render, staticRenderFns } from "./AutomationButtons.vue?vue&type=template&id=9022ce8a&"
import script from "./AutomationButtons.vue?vue&type=script&lang=js&"
export * from "./AutomationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports